<template>
  <q-card class="law-firm-users-card">
    <q-toolbar class="text-warning">
      <q-toolbar-title>
        <router-link :to="`/admin/accounts/${accountId}/users`" class="link text-warning">
          Law Firm Users
        </router-link>
      </q-toolbar-title>
      <q-icon name="fa fa-users" size="sm" />
    </q-toolbar>
    <q-separator />
    <q-card-section>
      <loader :task="task" />
      <div v-show="numUsers !== null" class="row">
        <div class="col-6">
          <span class="text-h3 text-bold">{{ numUsers }}</span>
          Team Member<span v-show="numUsers !== 1">s</span>
        </div>
        <div class="col-6 text-right" style="align-self: flex-end">
          <invite-user-btn
            :account-id="accountId"
            label="Add"
            flat
            rounded
            @invited="numUsers++"
          />
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<style lang="scss">
@import '../../styles/quasar.variables';

.law-firm-users-card {
  border-bottom: 3px solid $warning;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import repository from '../../user/user-repository';
import InviteUserBtn from '../../user/InviteUserBtn.vue';

interface Data {
  task: Promise<number>|null,
  numUsers: number|null
}

export default defineComponent({
  components: { Loader, InviteUserBtn },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
      numUsers: null,
    };
  },
  watch: {
    accountId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = repository.count(this.accountId);
      this.task.then((numUsers) => {
        this.numUsers = numUsers;
      });
    },
  },
});
</script>
